<p-fileUpload #fileForm [customUpload]="true" (uploadHandler)="uploadSchoolInvoiceFile($event.files, fileForm)"
[maxFileSize]="16000000">
</p-fileUpload>
